module.exports = __webpack_public_path__ + "img/03-B05.07f86cc1.png";